import { gql } from '@apollo/client'

const MENU_DATA_CONTEXT_FRAGMENT = gql`
  fragment MenuDataContextFragment on MenuDataContext {
    menuTitlePath
    menuTitleName
    menuTitleDescription
    menuTitleAddonDescriptors
    menuTitleMiscDescriptors
    parentMenuTitleName
    parentMenuTitleDescription
    parentMenuTitleAddonDescriptors
    parentMenuTitleMiscDescriptors
    grandParentMenuTitleName
    grandParentMenuTitleDescription
    grandParentMenuTitleAddongDescriptors
    grandParentMenuTitleMiscDescriptors
  }
`

export default MENU_DATA_CONTEXT_FRAGMENT
